import { useEffect, useState } from "react";

export const useBreakPoint = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isWideDesktop, setIsWideDesktop] = useState(false);

  useEffect(() => {
    const hasBreakPoint = () => {
      const screenWidth = window.innerWidth;

      setIsMobile(screenWidth < 640);
      setIsTablet(screenWidth >= 640 && screenWidth < 1024);
      setIsDesktop(screenWidth >= 1024);
      setIsWideDesktop(screenWidth >= 1700);
    };
    window.addEventListener("resize", hasBreakPoint);
    hasBreakPoint();
    return () => window.removeEventListener("resize", hasBreakPoint);
  }, []);

  return { sm: isMobile, lg: isTablet, xl: isDesktop, xxl: isWideDesktop };
};
